import { Orientation, TrinketSettings } from '@/domain/models/TrinketSettings'
import { ToastOptions } from '@/components/Common/ToastOptions'
import { TrinketGrid } from '@/domain/models/TrinketGrid'

export const version = process.env.PACKAGE_VERSION as string
export const TrinketGridStorageName = 'TrinketGrid'
export const PaletteStorageName = 'TrinketPalette'

export enum Tools {
    FILLER = 'FILLER',
    PICKER = 'PICKER',
    BORDER = 'BORDER',
    ERASER = 'ERASER',
    LINE = 'LINE',
    TEXT = 'TEXT',
    LINE_ERASER = 'LINE_ERASER',
    NONE = 'NONE'
}

export interface State {
    fireworks?: boolean,
    configuration: TrinketSettings,
    palette: string[],
    settingsModal: {
        show: boolean
    },
    trinketGrid: TrinketGrid,
    saveInterval?: number,
    toast?: ToastOptions,
    version: string
}

export const state = {
    fireworks: false,
    configuration: {
        grid: {
            width: 10,
            height: 10,
            orientation: Orientation.PORTRAIT,
            showGridHelper: true,
            gridHelperColor: 'hsl(0, 0%, 74%)',
            showGridAxis: true,
            gridAxisColor: 'hsl(0, 79%, 54%)'
        },
        point: {
            radius: 9,
            margin: 1
        },
        line: {
            continueLine: false
        },
        saving: {
            autoSave: {
                active: true,
                timeInterval: 180000
            },
            saveOnExit: true
        }
    },
    trinketGrid: {
        lines: [],
        points: [],
        texts: [],
        colors: {
            fill: '#42b983',
            stroke: '#42b983',
            lineStroke: '#42b983'
        },
        currentLine: undefined,
        selectedTool: Tools.NONE
    },
    saveInterval: undefined,
    toast: undefined,
    palette: ['#6a4f4b', '#f9683a', '#ff833a', '#ffa040', '#ffb04c', '#b4a647', '#629749', '#4c8c4a',
        '#39796b', '#428e92', '#4f83cc', '#5472d3', '#534bae', '#6746c3', '#7c43bd', '#bc477b',
        '#f05545', '#000a12', '#484848', '#4f5b62', '#707070', '#8d8d8d', '#9e9e9e', '#aeaeae',
        '#bdbdbd', '#e0e0e0'],
    settingsModal: {
        show: false
    },
    version
}

export const createInitialState = (): TrinketGrid => ({
    lines: [],
    points: [],
    texts: [],
    colors: {
        fill: '#42b983',
        stroke: '#42b983',
        lineStroke: '#42b983'
    },
    currentLine: undefined,
    selectedTool: Tools.NONE
})
